import React, { useState } from "react";
import { NotificationForm } from "./NotificationForm";
import { Button } from "../Button";
import { useSendNotifications } from "../../hooks/notifications/notifications.hooks";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { SendNotificationConfirmationModal } from "./SendNotificationConfirmationModal";
import { validateSendNotifications } from "./sendNotificationValidation";

export const SendNotification = () => {
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [audienceId, setAudienceId] = useState<number | null>(null);
  const [notificationCategoryKey, setNotificationCategoryKey] =
    useState<string>("");

  const [selectedAudeinceValue, setSelectedAudienceValue] = useState("");
  const [selectedAudineceCategory, setSelectNotificationCategory] =
    useState("");

  const [openConfirmationModal, setOpenConfirmationModal] =
    React.useState(false);

  const { isLoading: isSendingNotification, mutate: sendNotifications } =
    useSendNotifications({
      onSuccess: () => {
        dispatch(setSuccessMessage("Notification sent successfully."));
      },
      onError: (err) => dispatch(setErrorMessage(parseApiError(err))),
    });

  const onSendNotification = () => {
    const { message, isValid } = validateSendNotifications({
      text,
      title,
      audience_id: audienceId,
      category: notificationCategoryKey,
    });

    if (!isValid) {
      return dispatch(setWarningMessage(message));
    }

    sendNotifications({
      title,
      text,
      audience_id: audienceId,
      category: notificationCategoryKey,
    });
  };

  return (
    <>
      <div className="flex flex-col">
        <NotificationForm
          title={title}
          setTitle={setTitle}
          text={text}
          setText={setText}
          audienceId={audienceId}
          setAudienceId={setAudienceId}
          notificationCategoryKey={notificationCategoryKey}
          setNotificationCategoryKey={setNotificationCategoryKey}
          setSelectedAudienceValue={setSelectedAudienceValue}
          setSelectNotificationCategory={setSelectNotificationCategory}
        />

        <div>
          <Button
            loading={isSendingNotification}
            text="Send"
            onClick={() => {
              setOpenConfirmationModal(true);
            }}
          />
        </div>
      </div>
      <SendNotificationConfirmationModal
        open={openConfirmationModal}
        onClose={() => {
          setOpenConfirmationModal(false);
        }}
        selectedAudeinceValue={selectedAudeinceValue}
        selectedAudineceCategory={selectedAudineceCategory}
        onConfirmSendNotifications={() => {
          onSendNotification();
          setOpenConfirmationModal(false);
        }}
        title={title}
        text={text}
      />
    </>
  );
};
